import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { NoonReportStatusEnum } from '../../../types/ViewModel/AolEnums';
import { StatusIcon } from './NoonReportStatusIcon.styles';

type Props = {
    reportStatus: NoonReportStatusEnum;
};

const NoonReportStatusIcon: React.FC<Props> = (props) => {
    return (
        <>
            {props.reportStatus === NoonReportStatusEnum.Missing && (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="Missing AOL" />
                </StatusIcon>
            )}
            {props.reportStatus === NoonReportStatusEnum.Edited && (
                <StatusIcon className="status-icon status-edited">
                    <FontAwesomeIcon icon="edit" title="Edited AOL" />
                </StatusIcon>
            )}
            {props.reportStatus === NoonReportStatusEnum.Completed && (
                <StatusIcon className="status-icon status-completed">
                    <FontAwesomeIcon icon="check-circle" title="Completed AOL" />
                </StatusIcon>
            )}
            {props.reportStatus === NoonReportStatusEnum.Approved && (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="Approved AOL" />
                </StatusIcon>
            )}
        </>
    );
};

export default NoonReportStatusIcon;
